import { makeStyles } from '@material-ui/core';
import { Colors } from '../../../layout/theme-next';

export default makeStyles(theme => ({
  workflow: {
    width: '100%',
    background: Colors.background,
    margin: theme.spacing(2, 0),
    display: 'grid',
  },
  genericFlex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
  },
  accordion: {
    marginBottom: theme.spacing(1),
    border: `1px solid ${Colors.stroke}`,
    borderRadius: 8,

    '&:before': {
      display: 'none',
    },

    '&.Mui-expanded': {
      margin: `0 0 ${theme.spacing(1)}px`,
    },
  },

  summary: {
    minHeight: 64,

    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
    },
  },

  stageIcon: {
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  icon: {
    marginRight: theme.spacing(1),
    '&.Mui-expanded': {
      color: Colors.primary,
    },
  },
  iconButton: {
    width: 24,
    minHeight: 24,
    height: 24,
  },

  textSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    color: Colors.textBlack,
    fontWeight: 600,
    fontSize: 16,
  },
  info: {
    fontWeight: 400,
    fontSize: 12,
    color: Colors.textGray,
    marginTop: theme.spacing(0.25),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    width: '100%',
    padding: theme.spacing(0, 2, 2, 2),
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  stagePanel: {
    marginTop: theme.spacing(1),
    border: `1px solid ${Colors.stroke}`,
    borderRadius: theme.spacing(0.5),
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',

    '&.Mui-expanded': {
      marginTop: theme.spacing(1),
    },
    '&::before': {
      display: 'none',
    },
  },

  stageStatus: {
    fontWeight: 600,
    fontSize: 13,
    color: Colors.textGray,
    padding: theme.spacing(0.5, 1),
    cursor: 'default',
  },
  /** Stage States **/
  completed: {
    backgroundColor: Colors.successHighlight,
    border: `1px solid ${Colors.success}`,
  },
  inProgress: {
    backgroundColor: Colors.primaryHighlight,
    border: `1px dashed ${Colors.primary}`,
  },
  pending: {
    backgroundColor: Colors.gray,
    opacity: 0.9,
    border: `1px dashed ${Colors.stroke}`,
  },
  inReview: {
    backgroundColor: Colors.warningHighlight,
    border: `1px dashed ${Colors.warning}`,
  },
  stageOwnerContainer: {
    width: theme.spacing(40),

    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: theme.spacing(0.25, 0.75),
    },
  },
  summaryContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    paddingRight: theme.spacing(1),
  },

  leftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  subtitle: {
    color: Colors.textGray,
    marginTop: 2,
  },
  editableFieldsChip: {
    height: theme.spacing(3),
    fontSize: '0.75rem',
    fontWeight: 500,
    marginLeft: theme.spacing(2),
  },
  approverContainer: {
    display: 'flex',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    gap: `${theme.spacing(2)}px`,
    padding: theme.spacing(1),
    flexWrap: 'nowrap',
    boxSizing: 'border-box',

    '&::-webkit-scrollbar': {
      height: 8,
    },

    '&::-webkit-scrollbar-track': {
      background: Colors.lightGray3,
      borderRadius: '10px !important',
    },

    '&::-webkit-scrollbar-thumb': {
      background: `${Colors.textGray} !important`,
      borderRadius: '10px !important',
      cursor: 'pointer',
    },
  },
  approverCard: {
    width: theme.spacing(30),
    minWidth: theme.spacing(30),
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    borderTop: `4px solid ${Colors.warning}`,
    position: 'relative',
  },
  approvedCard: {
    borderTop: `4px solid ${Colors.approve}`,
  },
  rejectedCard: {
    borderTop: `4px solid ${Colors.reject}`,
  },
  pendingCard: {
    borderTop: `4px solid ${Colors.warning}`,
  },
  currentUserCard: {
    border: `2px solid ${Colors.primary}`,
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  approverNameRow: {
    display: 'flex',
    flex: 1,
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: `${theme.spacing(1)}px`,
  },
  approverName: {
    fontWeight: 600,
    marginBottom: theme.spacing(3),
  },
  youLabel: {
    marginLeft: theme.spacing(0.75),
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  requiredIndicator: {
    marginLeft: theme.spacing(0.5),
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.error.main,
  },
  optionalLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  sectionTitle: {
    color: Colors.textGray,
    display: 'block',
    marginBottom: theme.spacing(0.5),
  },
  status: {
    fontWeight: 600,
  },
  pendingStatus: {
    color: Colors.warning,
  },
  approvedStatus: {
    color: Colors.success,
  },
  rejectedStatus: {
    color: Colors.error,
  },
  rejectBtn: {
    color: Colors.error,
    border: `1px solid ${Colors.error}`,
    backgroundColor: Colors.errorHighlight,
    textTransform: 'uppercase',
    '&:hover, &:focus': {
      color: Colors.error,
      border: `1px solid ${Colors.error}`,
      backgroundColor: Colors.errorLight,
    },
  },
  draftStatus: {
    color: Colors.statusDraft,
  },
  abandonedStatus: {
    color: Colors.statusClosed,
  },
  reviewedAt: {
    marginTop: theme.spacing(0.5),
    color: Colors.textGray,
  },
  youChip: {
    background: Colors.primaryBg,
    color: Colors.primary,
  },
  optionalChip: {
    backgroundColor: Colors.warningHighlight,
  },
  actions: {
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  stageStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.spacing(2)}px`,
  },
  customTooltip: {
    backgroundColor: Colors.black,
    whiteSpace: 'pre-wrap',
  },
  customArrow: {
    color: Colors.black,
  },
  optionalRejectionIcon: {
    fontSize: 18,
    marginLeft: theme.spacing(0.5),
  },
  deleteApprovalIcon: {
    fontSize: 16,
    position: 'absolute',
    bottom: theme.spacing(0.5),
    right: theme.spacing(1),
    cursor: 'pointer',
  },
}));
